<template>
  <div v-loading="loading">
    <Header />
    <div class="detail">
      <!-- baseURL + -->
      <el-upload class="upload-demo" drag :action="'https://apimanage.rakumart.com/tools.pdftotxt'" multiple :headers="{
        AdminToken: 'Bearer ' + token
      }" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <i class="el-icon-upload" style="margin-top: 250px;"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip" style="font-size: 30px;">只能转换固定的PDF文件</div>
      </el-upload>
    </div>
  </div>
</template>
<script>
import Header from '../../components/header/detailHeader'
import { saveAs } from 'file-saver';
export default {
  metaInfo() {
    return {
      title: 'PDF转TXT',
    };
  },
  components: {
    Header,
  },
  data() {
    return {
      token: localStorage.getItem('japan_access_token'),
      name: '',
      loading: false,
    };
  },
  methods: {
    handleAvatarSuccess(res) {
      this.loading = false
      if (res.msg) return this.$message.error(res.msg)
      let str = new Blob([res], { type: 'text/plain;charset=utf-8' });
      saveAs(str, `${this.name}.txt`);
      this.$message.success('已下载到浏览器')
    },
    // 上传前
    beforeAvatarUpload(file) {
      this.name = file.name.split('.')[0]
      const isPDF = file.type === "application/pdf";
      this.loading = true
      if (!isPDF) {
        this.loading = false
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isPDF
    },
  }
}
</script>
<style lang='scss' scoped>
.detail {
  min-width: 1860px;
  padding: 100px 20px;

  /deep/.el-upload {
    width: 100%;
  }

  /deep/.el-upload-dragger {
    width: 100%;
    height: 600px;
  }
}
</style>